<div class="content-wrapper">
    <h3>Terms and Conditions</h3>
    <h4>{{ title }}</h4>
    @if(loading) {
    <app-cf-loader>
        <p>Loading data...</p>
    </app-cf-loader>
    } @else {
    <form>
        <div class="terms" [innerHTML]="termsText"></div>
    </form>
    }
    <tracker-buttons [hasPreviousButton]="true" [hasNextButton]="false"></tracker-buttons>
</div>